import { FlexCol, FlexColLg } from 'components/Elements';
import styled from 'styled-components';
import { sizes } from 'theme';

export const ContentColumn = styled(FlexColLg)`
    flex: 1; /* grow to fill space between header & footer */
    width: 100%;
    max-width: ${sizes.learnerImmersiveContentMaxWidth};
    margin: ${sizes.spacingMd} auto ${sizes.spacingLg} auto;
    padding: 0 ${sizes.edgePadding};
`;

export const LearnerActivityBase = styled(FlexCol)`
    flex: 1 1 auto; /* push course navigation buttons to bottom of activity view */
`;
